import {AfterViewInit, Component} from '@angular/core';
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatDivider} from "@angular/material/divider";
import {MatIcon} from "@angular/material/icon";
import {Doctor, Patient} from "@interfaces/doctors";
import {DoctorsService} from "@services/doctors/doctors.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";

@Component({
  selector: 'app-patient-list',
  imports: [
    MatProgressBar,
    MatDivider,
    MatIcon,
  ],
  templateUrl: './patient-list.component.html',
  standalone: true,
  styleUrl: './patient-list.component.scss'
})
export class PatientListComponent implements AfterViewInit {
  doctors?: Doctor[];
  patients?: Patient[];

  constructor(
    private doctorsService: DoctorsService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.doctorsService.doctorsListObservable$
      .subscribe((doctors: any) => {
        this.doctors = doctors;
        this.route.paramMap.subscribe(params => {
          const doctorId = params.get('doctorId') ?? '';
          this.loadDoctors(doctorId);
        });
      });

  }

  ngAfterViewInit() {
  }

  loadDoctors(doctorId: string) {
    if (doctorId && this.doctors) {
      this.doctors.forEach((doctor: Doctor) => {
        if (doctor.id === doctorId) {
          this.patients = doctor.patients;
        }
      });
    }
  }

  goBack() {
    this.location.back();
  }

  openPatient(patient: Patient) {
    this.router.navigate([`${patient.id}`], {relativeTo: this.route});
  }
}
